export default __webpack_public_path__ + "static/media/BiosensorFigure12.eb342c70.svg";